import { takeEvery, takeLatest } from 'redux-saga/effects';
import { ZONES_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_ZONE_LIST,
  CREATE_ZONE,
  DELETE_ZONE,
  EDIT_ZONE_BY_ID,
  LOAD_ZONE_BY_ID,
  EXPORT_ZONES,
  IMPORT_ZONES,
  LOAD_ZONE_HISTORY,
  LOAD_HISTORY_BY_ID,
} from '../actions';

import loadZoneList from './loadZoneList';
import createZone from './createZone';
import loadZoneById from './loadZoneById';
import editZoneById from './editZoneById';
import deleteZone from './deleteZone';
import exportZones from './exportZones';
import importZones from './importZones';
import loadHistoryById from './loadHistoryById';
import loadZoneHistory from './loadZoneHistory';

export default function* watchDashboard() {
  yield takeLatest(ZONES_MODULE + LOAD_ZONE_LIST, loadZoneList);
  yield takeLatest(ZONES_MODULE + CREATE_ZONE, createZone);
  yield takeEvery(ZONES_MODULE + LOAD_ZONE_BY_ID, loadZoneById);
  yield takeEvery(ZONES_MODULE + EDIT_ZONE_BY_ID, editZoneById);
  yield takeEvery(ZONES_MODULE + DELETE_ZONE, deleteZone);
  yield takeEvery(ZONES_MODULE + EXPORT_ZONES, exportZones);
  yield takeEvery(ZONES_MODULE + IMPORT_ZONES, importZones);
  yield takeEvery(ZONES_MODULE + LOAD_ZONE_HISTORY, loadZoneHistory);
  yield takeEvery(ZONES_MODULE + LOAD_HISTORY_BY_ID, loadHistoryById);
}
